import * as React from "react";
import { NumericInput, Radio } from "../../externals";
import { defMonthlyCronFirst, defMonthlyCronSecond, } from "../defaultCronOptions";
import { StartsAtSelector } from "../customInputs/StartsAtSelector";
import { setValue } from "../utils";
import { DayNumDaySelector } from "../customInputs/DayNumDaySelector";
export class MonthlyPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onChangeMonthly = (cron, value, type) => {
            switch (type) {
                case "month":
                    cron.month = "1/" + value;
                    break;
                case "monthday":
                    cron.monthday = value;
                    break;
            }
            this.props.onChange(cron);
        };
        this.state = {
            monthlyFirstOpt: true,
        };
    }
    render() {
        const cron = Object.assign({}, this.props.cron);
        return (React.createElement("div", { id: "monthlyPanel" },
            React.createElement("div", { id: "monthlyFirstOpt", className: "tab-option-inline" },
                React.createElement(Radio, { label: "Day", checked: this.state.monthlyFirstOpt, onChange: () => {
                        this.setState({ monthlyFirstOpt: true });
                        this.props.onChange(Object.assign(Object.assign({}, defMonthlyCronFirst), { minutes: this.props.startsAt[1], hours: this.props.startsAt[0] }));
                    }, style: { paddingTop: "8px" }, className: "option-item" }),
                React.createElement(NumericInput, { allowNumericCharactersOnly: false, max: 31, min: 1, className: "option-item", value: this.state.monthlyFirstOpt ? cron.monthday : "1", onValueChange: (value) => this.onChangeMonthly(cron, value.toString(), "monthday"), disabled: !this.state.monthlyFirstOpt }),
                React.createElement("label", { className: "option-item" }, "of every"),
                React.createElement(NumericInput, { allowNumericCharactersOnly: false, max: 11, min: 1, className: "option-item", value: setValue(this.state.monthlyFirstOpt, cron.month), onValueChange: (value) => this.onChangeMonthly(cron, value.toString(), "month"), disabled: !this.state.monthlyFirstOpt }),
                React.createElement("label", null, "month(s)")),
            React.createElement("div", { id: "monthlySecondOpt", className: "tab-option-inline", style: { paddingTop: "8px" } },
                React.createElement(Radio, { label: "The", checked: !this.state.monthlyFirstOpt, onChange: () => {
                        this.setState({ monthlyFirstOpt: false });
                        this.props.onChange(Object.assign(Object.assign({}, defMonthlyCronSecond), { minutes: this.props.startsAt[1], hours: this.props.startsAt[0] }));
                    }, className: "option-item", style: { paddingTop: "8px" } }),
                React.createElement(DayNumDaySelector, { currentWeekday: cron.weekday, onChange: (value) => {
                        this.props.onChange(Object.assign(Object.assign({}, cron), { weekday: value }));
                    }, disabled: this.state.monthlyFirstOpt }),
                React.createElement("label", { className: "option-item" }, "of every"),
                React.createElement(NumericInput, { allowNumericCharactersOnly: false, max: 11, min: 1, className: "option-item", value: setValue(!this.state.monthlyFirstOpt, cron.month), onValueChange: (value) => this.onChangeMonthly(Object.assign({}, cron), value.toString(), "month"), disabled: this.state.monthlyFirstOpt }),
                React.createElement("label", null, "month(s)")),
            React.createElement(StartsAtSelector, { startsAtChange: (value) => this.props.startsAtChange(value), startsAt: this.props.startsAt })));
    }
}
//# sourceMappingURL=MonthlyPanel.js.map